import styled from 'styled-components';

export const ContainerTitle = styled.div`
  white-space: pre-wrap;
`;

interface IAreaChildrenTooltip {
  $isWidthChildren: boolean;
}
export const AreaChildrenTooltip = styled.div`
  width: ${(props: IAreaChildrenTooltip) =>
    props.$isWidthChildren ? 'fit-content' : 'auto'};
`;

